module.exports = __webpack_public_path__ + "static/media/logo-twitch.cd5a611b.svg";